// extracted by mini-css-extract-plugin
export default {"input-main":"InputSection_input-main__Zntos","widthChange":"InputSection_widthChange__mnwlF"};